export default __webpack_public_path__ + "static/media/markdown.2334cabe.svg";